import { render, staticRenderFns } from "./score-bottom-bar.vue?vue&type=template&id=754104a6&scoped=true&"
import script from "./score-bottom-bar.vue?vue&type=script&lang=js&"
export * from "./score-bottom-bar.vue?vue&type=script&lang=js&"
import style0 from "./score-bottom-bar.vue?vue&type=style&index=0&id=754104a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754104a6",
  null
  
)

export default component.exports